import { z } from 'zod';

import { Option } from '../../types/Option';

const poles = ['1P', '1P+N', '1P+M', '2P', '2P+M', '3P', '3P+N', '4P'] as const;

export type Poles = (typeof poles)[number];

const options = [
    { value: '1P', label: '1P' },
    { value: '1P+N', label: '1P+N' },
    { value: '1P+M', label: '1P+M' },
    { value: '2P', label: '2P' },
    { value: '2P+M', label: '2P+M' },
    { value: '3P', label: '3P' },
    { value: '3P+N', label: '3P+N' },
    { value: '4P', label: '4P' },
] as Option<Poles>[];

const numericValueMap: Record<Poles, number> = {
    '1P': 1,
    '1P+N': 2,
    '1P+M': 2,
    '2P': 2,
    '2P+M': 3,
    '3P': 3,
    '3P+N': 4,
    '4P': 4,
};

export const Poles = {
    validator: z.enum(poles),
    options,
    numericValueMap,
};

export enum PoleType {
    AcWithoutInterrupt,
    AcWithInterrupt,
    DcWithoutInterrupt,
    DcWithInterrupt,
    All,
}
